import { IconSpriteMoneyBills } from '@propertyfinder/icons';
import { FunctionalComponent, h } from 'preact';

import { ProjectPhaseEnum } from 'common/data/project/phase.enum';
import { i18nTranslate } from 'common/helper/i18n/translate';

import { PropertyOffPlanTagsComponentPropsInterface } from './component-props.interface';
import { PropertyOffPlanTagsTagInterface } from './tag.interface';

export const PropertyOffPlanTagsComponent: FunctionalComponent<PropertyOffPlanTagsComponentPropsInterface> = ({
  project,
}) => {
  const tags: PropertyOffPlanTagsTagInterface[] = [];

  if (parseInt(project.down_payment_rate, 10) > 0 || project.installment_years > 0) {
    tags.push({
      text: i18nTranslate('Payment Plan'),
      icon: IconSpriteMoneyBills,
    });
  }

  if (Object.values(ProjectPhaseEnum).includes(project.phase_id)) {
    tags.push({
      text: i18nTranslate(
        project.phase_id === ProjectPhaseEnum.UNDER_CONSTRUCTION ? 'Delivered in' : 'Construction completed'
      ),
      additionalText: project.phase_id === ProjectPhaseEnum.UNDER_CONSTRUCTION ? project.delivery_date : '',
    });
  }

  if (!tags.length) {
    return null;
  }

  return (
    <ul
      aria-label='Off Plan Tags'
      className='property-off-plan-tags
    '
    >
      {tags.map(({ icon: Icon, ...tagProps }, index) => (
        <li key={index} className='property-off-plan-tags__item'>
          {Icon && <Icon className='property-off-plan-tags__icon' />}
          {tagProps.text}
          {tagProps.additionalText && <span>&nbsp;{tagProps.additionalText}</span>}
        </li>
      ))}
    </ul>
  );
};
